import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Motion";
import { SERVICES, RATES_PLACEHOLDER } from "../../data/content";

export const PrivatePayRates = () => (
  <section id="rates" className="scroll-mt-24 bg-[#F4F1EA] py-20 sm:py-28 lg:py-32" data-testid="private-pay-rates-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-7">
          <Eyebrow>Private pay</Eyebrow>
          <h2 className="font-serif-display mt-4 text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl" data-testid="private-pay-rates-heading">
            Private pay <span className="italic text-[#A9533A]">rates</span>
          </h2>
        </Reveal>
        <Reveal className="lg:col-span-5" delay={0.1}>
          <p className="text-base leading-relaxed text-[#4A554D] md:text-lg" data-testid="private-pay-rates-intro">
            We keep rates simple and share them during your first conversation, so what you see here stays current. No obligation.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 overflow-hidden rounded-[1.5rem] border border-[#E2DCD0] bg-[#FDFBF7] lg:mt-16" data-testid="rates-table">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={i * 0.06}>
            <div className={`flex flex-col gap-4 p-6 sm:flex-row sm:items-center sm:justify-between sm:p-8 ${i > 0 ? "border-t border-[#E2DCD0]" : ""}`} data-testid={`rate-row-${s.slug}`}>
              <div>
                <p className="font-mono-ui text-xs tracking-[0.2em] text-[#A9533A]">{s.num}</p>
                <h3 className="font-serif-display mt-1 text-2xl text-[#1E2621] sm:text-3xl">{s.name}</h3>
                <p className="mt-1 max-w-md text-sm text-[#4A554D]">
                  {s.privateOnly ? "Private pay only" : "Ohio Medicaid (eligible individuals) or private pay"}
                </p>
              </div>
              <p className="font-mono-ui inline-block shrink-0 rounded-lg border border-dashed border-[#C86D51]/60 bg-[#FFF8F0] px-4 py-2.5 text-sm text-[#8A5416]" data-testid={`rate-placeholder-${s.slug}`}>
                [Rate available upon request]
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal>
        <p className="mt-6 text-sm leading-relaxed text-[#4A554D]" data-testid="rates-note">
          Coverage depends on eligibility and a clinical assessment. We'll help you understand your options.
        </p>
        <Link to="/contact" className="group mt-6 inline-flex items-center gap-2 rounded-full bg-[#1E2621] px-6 py-3.5 text-sm font-medium text-[#F4F1EA] transition-colors hover:bg-[#A9533A]" data-testid="rates-contact-button">
          Ask us for current rates <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
        </Link>
      </Reveal>
    </div>
  </section>
);
